/** @format */

interface Props {
  payload: {
    value: number;
  };
  x: number;
  y: number;
}

const CustomYTick = ({payload, y, x}: Props) => {
  return (
    <text dx={-20} fill='#FFFFFF' fontSize={10} fontWeight='400' x={x} y={y}>
      {payload.value}
    </text>
  );
};

export {CustomYTick};
